import React from "react";
import { Alert, Card, Empty, Space, Tag, Typography } from "antd";
import { statusColor } from "../constants";

const { Title, Text } = Typography;

export function LmsPageHeader({ title, description, extra }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 16,
        marginBottom: 20,
        flexWrap: "wrap",
      }}
    >
      <div>
        <Title level={3} style={{ margin: 0 }}>
          {title}
        </Title>
        {description && (
          <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
            {description}
          </Text>
        )}
      </div>
      {extra && <Space wrap>{extra}</Space>}
    </div>
  );
}

export function LmsStatusTag({ status }) {
  return <Tag color={statusColor(status)}>{status || "Unknown"}</Tag>;
}

export function canEditLmsRow(record) {
  return record?.mine !== false;
}

export function LmsOwnershipTag({ record }) {
  if (!record || record.mine === undefined) return null;
  if (record.mine === true && record.createdByMe === true)
    return <Tag color="green">Created by you</Tag>;
  if (record.mine === true)
    return (
      <Tag color="blue">
        Inherited{record.createdByName ? ` from ${record.createdByName}` : ""}
      </Tag>
    );
  return (
    <Tag>
      Read-only{record.createdByName ? ` · ${record.createdByName}` : ""}
    </Tag>
  );
}

export function LmsErrorAlert({ error, onClose }) {
  if (!error) return null;
  return (
    <Alert
      type="error"
      showIcon
      closable={Boolean(onClose)}
      onClose={onClose}
      message={error}
      style={{ marginBottom: 16 }}
    />
  );
}

export function LmsSectionCard({ title, extra, children, ...props }) {
  return (
    <Card title={title} extra={extra} {...props}>
      {children}
    </Card>
  );
}

export function LmsEmpty({ description = "No LMS records found" }) {
  return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />;
}

export function formatDate(value, fallback = "—") {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTime(value, fallback = "—") {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

